<div class="user-profile">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header">
                <h4 class="mb-0 text-uppercase"><i class="mdi mdi-account"></i> Profile</h4>
            </div>
            <div class="row d-flex align-items-center" *ngIf="data">
                <div class="col-md-3">
                    <div class="avatar-profile text-center">
                        <div class="avatar mb-2"><img src="https://speedcdn.io/assets/radheexch-client/icons/profile-icon.svg" alt="profile"></div>
                        <h2>{{data?.username}}</h2>
                        <!-- <h3>David1 12345</h3> -->
                    </div>
                </div>
                <div class="col-md-9">
                    <div class="table-responsive">
                        <table class="table mb-0 profile-table">
                            <tbody>
                                <!-- <tr>
                                    <th>Name:</th>
                                    <td>David11</td>
                                </tr> -->
                                <tr>
                                    <th>User Name:</th>
                                    <td>{{data?.username}}</td>
                                </tr>
                                <!-- <tr>
                                    <th>Date Of Joining:</th>
                                    <td>2021-11-30 15:04:34</td>
                                </tr> -->
                                <tr>
                                    <th>Balance:</th>
                                    <td><i class="mdi mdi-currency-inr"></i> {{data?.available_balance}}</td>
                                </tr>
                                <tr>
                                    <th>Exposure:</th>
                                    <td><i class="mdi mdi-currency-inr"></i> {{data?.expose}}</td>
                                </tr>
                                <tr>
                                    <th>My Wallet:</th>
                                    <td><i class="mdi mdi-currency-inr"></i> {{data?.balance}}</td>
                                </tr>
                                <tr>
                                    <th>Profit:</th>
                                    <td><i class="mdi mdi-currency-inr"></i> <span
                                            [ngClass]="data.pl >= 0 ? 'profit' : 'loss'">{{data?.pl}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row d-flex align-items-center" *ngIf="!data">
                <app-loader class="no-overlay"></app-loader>
            </div>
        </div>
    </div>
</div>